<template>
  <section>
    <h2>Page not found</h2>
    <p>This page could not be found.</p>
  </section>
</template>